import cx from "classnames";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { ProgressBar } from "react-step-progress-bar";

import reload from "../../../../assets/images/reload.svg";

import "react-toastify/dist/ReactToastify.css";

import Module from "../../../../../src/assets/images/course-modals.svg";
import ModuleLock from "../../../../../src/assets/images/module-lock.svg";
// import RightChevron from "../../../../../src/assets/images/right-chevron-black.svg";
import CourseAssessmentIcon from "../../../../../src/assets/images/course-assessment-icon.svg";
import ArrowIcon from "../../../../../src/assets/images/arrow-icon.svg";
import TickIcon from "../../../../../src/assets/images/tick-icon.png";

import {
  ASSESSMENT_ALLOWED,
  FEEDBACK_ALLOWED,
  IS_COURSE_POST_ASSESSMENT_AVAILABLE,
  IS_POST_MODULE_ASSESSMENT_AVAILABLE,
  IS_RETAKE_ATTEMPT,
  LMS_MODULE_ID,
  LMS_MODULE_NAME,
  MODULE_NUMBER,
  RETAKE_VIEW,
} from "../../../../utils/cookiesmanager";

import HeaderModule from "../ModuleHeaderComponent";
import Shimmer from "../ShimmerComponent";
import EnrollmentSuccessfulComponent from "../EnrollmentSuccessfulComponent";

import { BUTTON_VARIANTS } from "../constant";
import Button from "../ButtonComponent";

import { ModuleCompletionStatus } from "./constant";
import { useGetModuleTypeList } from "./queries";
import { useRefreshNow, useUpdateEnrollNow } from "./mutation";

import { useQueryClient } from "@tanstack/react-query";

import { useGetTranslatedText } from "../queries";

import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { QueryKeys } from "../../../../utils/queryKeys";

import styles from "./styles.module.scss";

const ModuleListUiComponent = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [enrollmentSuccessfull, setEnrollmentSuccessfull] = useState(false);
  const [isEnrolledButtonEnabled, setIsEnrolledButtonEnabled] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const courseTitle = searchParams.get("courseName");
  const courseId = searchParams.get("courseId");
  const languageId = localStorage.getItem("l_id") || 1;
  const isPostCourseAssessmentAvailable = localStorage.getItem(
    IS_COURSE_POST_ASSESSMENT_AVAILABLE,
  );

  const { data, isLoading, isFetching, refetch } = useGetModuleTypeList({
    courseId,
    languageId,
  });

  const { mutate: enrollNow, isPending: enrolling } = useUpdateEnrollNow();

  // const { mutate: refreshNow, isPending: refreshLoader } = useRefreshNow({
  //   onSuccess: () => {
  //     console.log("hello Api Call");
  //     queryClient.invalidateQueries({
  //       queryKey: [QueryKeys.MODULE_TYPE_LIST],
  //     });
  //     queryClient.refetchQueries({
  //       queryKey: [QueryKeys.MODULE_TYPE_LIST],
  //     });
  //     refetch();
  //   },
  //   onError: (error) => {
  //     toast.error(error?.message || "Something went wrong");
  //   },
  // });

  const { mutate: refreshNow, isPending: refreshLoader } = useRefreshNow({
    onSuccess: async () => {
      console.log("hello Api Call");

      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.MODULE_TYPE_LIST],
      });

      await queryClient.refetchQueries({
        queryKey: [QueryKeys.MODULE_TYPE_LIST],
      });

      refetch();
    },

    onError: (error) => {
      console.log("Mutation Error:", error);
      toast.error(error?.message || "Something went wrong");
    },
  });

  const modulesData = data?.response || {};

  const userTypeId = localStorage.getItem("userTypeId");

  const { data: translatedTextResponse } = useGetTranslatedText(languageId);

  const { data: translatedText = [] } = translatedTextResponse || {};

  const {
    enroll: isEnrolled,
    preAssessment,
    courseDescription: courseInfo = [],
    courseCompleteStatus,
    modules = [],
  } = modulesData;

  const { feedBack, retakeView, retakeAttempt, certificate } =
    courseCompleteStatus || {};

  const handleRedirection = () => navigate("/user/course");

  const queryClient = useQueryClient();

  const handleEnrollNow = () => {
    enrollNow(
      { courseId },
      {
        onSuccess: (response) => {
          const { status, error, response: apiResponse } = response?.data || {};
          if (!status) throw new Error(error || "Enrollment failed");

          queryClient.invalidateQueries({
            queryKey: [QueryKeys.MODULE_TYPE_LIST],
          });

          setEnrollmentSuccessfull(true);
          setIsEnrolledButtonEnabled(false);
          toast.success(apiResponse?.message);
        },
      },
    );
  };

  const handleClick = () => {
    sessionStorage.setItem(ASSESSMENT_ALLOWED, "true");

    if (preAssessment === 1) {
      setEnrollmentSuccessfull(false);
      return;
    }
    navigate(
      `/user/pre-assessment?courseId=${courseId}&courseName=${courseTitle}`,
    );
  };

  const handleCourseAssessmentRedirection = () => {
    sessionStorage.setItem(ASSESSMENT_ALLOWED, "true");
    if (feedBack === 2) {
      navigate(
        `/user/post-course-feedback?courseId=${courseId}&courseName=${courseTitle}`,
      );

      return;
    }

    if (retakeAttempt === 0) {
      const isRetakeAttempt =
        retakeAttempt === 0 && retakeView === 1 ? true : false;

      localStorage.setItem(IS_RETAKE_ATTEMPT, isRetakeAttempt);
      navigate(
        `/user/post-course-assessment?courseId=${courseId}&courseName=${courseTitle}`,
      );

      return;
    }
  };

  const renderAssessmentText = () => {
    localStorage.setItem(RETAKE_VIEW, retakeView);
    localStorage.setItem(FEEDBACK_ALLOWED, feedBack);

    if (!isAllModulesCompleted) {
      return (
        <p className={styles["course-status"]}>
          {getTranslatedText(
            translatedText,
            "key_unlock_assessment",
            "Complete all modules to unlock the assessment and earn your certificate.",
          )}
        </p>
      );
    }

    if (feedBack === 2) {
      const text =
        Number(courseId) === 8
          ? "Share feedback"
          : "Share feedback to get certificate";

      return (
        <p className={styles["start-assessment"]}>
          {getTranslatedText(
            translatedText,
            Number(courseId) === 8
              ? "key_share_feedback"
              : "key_share_feedback",
            text,
          )}
        </p>
      );
    }

    if (retakeAttempt === 0 && retakeView === 1) {
      return (
        <p className={styles["course-complete"]}>
          {userTypeId === "12" && courseId === "8"
            ? "Course Completed"
            : "Certificate earned. You can try once more to earn the Certificate of Excellence by scoring 75% or above."}
        </p>
      );
    }

    if (retakeAttempt === 0) {
      return (
        <p className={styles["start-assessment"]}>
          {getTranslatedText(
            translatedText,
            "key_start_assessment",
            "Start assessment",
          )}
        </p>
      );
    }

    if (certificate === 0) {
      return (
        <p className={styles["course-complete"]}>
          {userTypeId === "12" && courseId === "8"
            ? "Course Completed"
            : "Course Completion Certificate Earned"}
        </p>
      );
    }
    if (certificate === 1) {
      return (
        <p className={styles["course-complete"]}>
          {userTypeId === "12" && courseId === "8"
            ? "Course Completed"
            : "Certificate of Excellence Earned"}
        </p>
      );
    }

    return null;
  };

  const handleCourseRedirection = (item, index) => {
    if (showMessage) return;

    const { completionStatus, moduleID, moduleTitle } = item || {};
    localStorage.setItem(
      IS_POST_MODULE_ASSESSMENT_AVAILABLE,
      item?.postAssessmentAvailable,
    );

    localStorage.setItem(LMS_MODULE_ID, moduleID);
    localStorage.setItem(LMS_MODULE_NAME, moduleTitle);
    sessionStorage.setItem(ASSESSMENT_ALLOWED, "true");
    localStorage.setItem(MODULE_NUMBER, index);

    if (
      preAssessment === 0 &&
      completionStatus === ModuleCompletionStatus.IN_PROGRESS &&
      isEnrolled
    ) {
      navigate(
        `/user/pre-assessment?courseId=${courseId}&courseName=${courseTitle}`,
      );
      return;
    }

    if (
      completionStatus === ModuleCompletionStatus.COMPLETED ||
      completionStatus === ModuleCompletionStatus.IN_PROGRESS
    ) {
      navigate(
        `/user/chapter-list?courseId=${courseId}&moduleId=${moduleID}&courseName=${courseTitle}`,
      );
      return;
    }

    if (!isEnrolled) {
      setShowMessage(true);
      toast.info("Please enrolled first to start learning", {
        onClose: () => setShowMessage(false),
      });
      return;
    }
    if (completionStatus === ModuleCompletionStatus.LOCK) {
      setShowMessage(true);
      toast.info("Locked! Complete the previous module to unlock this one.", {
        onClose: () => setShowMessage(false),
      });
      return;
    }
  };

  const isAllModulesCompleted =
    modules?.length && modules?.every((item) => item?.percentage === "100.00%");

  const handleClickRefresh = () => {
    refreshNow();
  };

  return (
    <>
      <HeaderModule title={courseTitle} onBackClick={handleRedirection} />

      <div className={styles["main-container"]}>
        <div className={styles["bg-fixed"]}></div>
        {isLoading || isFetching ? (
          <Shimmer width="100%" height="220px" borderRadius="16px" />
        ) : (
          <div className={styles["about-course-wrapper"]}>
            <div className={styles["module-content-container"]}>
              <div className={styles["module-content"]}>
                {courseInfo?.[0]?.courseTitle}
              </div>

              <div
                className={cx(
                  styles["module-content-description"],
                  !isExpanded && styles.clamped,
                )}
                dangerouslySetInnerHTML={{
                  __html: courseInfo?.[0]?.courseContent || "",
                }}
              />

              {courseInfo?.[0]?.courseContent && (
                <span
                  className={styles["read-more"]}
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded
                    ? getTranslatedText(
                        translatedText,
                        "key_read_less",
                        "Read less",
                      )
                    : getTranslatedText(
                        translatedText,
                        "key_read_more",
                        "Read more...",
                      )}
                </span>
              )}
            </div>

            <div className={styles["content-wrapper"]}>
              <div className={styles["module-container"]}>
                <div className={styles["module-icon"]}>
                  <img src={Module} alt="module" />
                </div>
                <div className={styles["container-title"]}>
                  {modules?.length} Modules
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4">
                {(!isEnrolled || isEnrolledButtonEnabled) && (
                  <Button
                    label={
                      enrolling
                        ? "Enrolling..."
                        : getTranslatedText(
                            translatedText,
                            "key_enroll_now",
                            "Enroll Now",
                          )
                    }
                    buttonVariant={BUTTON_VARIANTS.PRIMARY}
                    className={styles["button-class"]}
                    onClick={handleEnrollNow}
                    disabled={enrolling || isEnrolledButtonEnabled}
                  />
                )}

                <button
                  className="flex items-center text-[#3C57AD] text-[14px] border border-[#2c3ea2] px-10 py-2 rounded-[14px]"
                  onClick={() => handleClickRefresh()}
                >
                  {!refreshLoader ? (
                    <>
                      <img src={reload} alt="reload" className="mr-1" />
                      Refresh Score
                    </>
                  ) : (
                    "Refreshing..."
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className={styles["all-course-wrapper"]}>
          {isLoading || isFetching
            ? [...Array(6)].map((_, index) => (
                <Shimmer
                  key={index}
                  width="100%"
                  height="96px"
                  borderRadius="10px"
                />
              ))
            : modules?.map((item, index) => (
                <div
                  key={item?.moduleID}
                  className={cx(
                    styles["course-wrapper"],
                    item?.completionStatus !== ModuleCompletionStatus.LOCK &&
                      styles.cursor,
                    item?.completionStatus ===
                      ModuleCompletionStatus.IN_PROGRESS &&
                      styles["unlocked-course"],
                    // item?.completionStatus ===
                    // ModuleCompletionStatus.LOCK  && styles.pointer
                  )}
                  onClick={() => handleCourseRedirection(item, index + 1)}
                >
                  <div className={styles.course}>
                    <div className={styles["course-id"]}>
                      {item?.percentage === "100.00%" ? (
                        <img src={TickIcon} alt="Completed" />
                      ) : (
                        index + 1
                      )}
                    </div>

                    <div className={styles["course-detail"]}>
                      <p className={styles["course-description"]}>
                        {item?.moduleTitle}
                      </p>

                      {item?.completionStatus ===
                        ModuleCompletionStatus.IN_PROGRESS && (
                        <>
                          {item?.percentage !== "0.00%" &&
                          item?.percentage !== "100.00%" ? (
                            <div className={styles["progress-bar-wrapper"]}>
                              <ProgressBar
                                percent={+item?.percentage?.replace("%", "")}
                                filledBackground="linear-gradient(to right, #111E5B, #274CC3)"
                                width="150px"
                              />
                              <p className={styles["course-percentage"]}>
                                {item?.percentage}
                              </p>
                            </div>
                          ) : (
                            <p className={styles["course-start"]}>
                              {preAssessment === 0
                                ? "Start Pre-Assessment"
                                : "Start Learning"}
                            </p>
                          )}
                        </>
                      )}

                      {item.percentage === "100.00%" && (
                        <p className={styles["course-complete"]}>Completed</p>
                      )}
                    </div>
                  </div>

                  {item?.completionStatus === ModuleCompletionStatus.LOCK ? (
                    <img src={ModuleLock} alt="icon" />
                  ) : (
                    <img
                      src={ArrowIcon}
                      className={styles["assessment-chevron"]}
                      alt="icon"
                    />
                  )}
                </div>
              ))}

          {!isLoading &&
            (isPostCourseAssessmentAvailable === "1" ? (
              <div
                className={cx(
                  styles["course-wrapper"],
                  styles["assessment-card"],
                  isAllModulesCompleted
                    ? styles["course-assessment"]
                    : styles["pointer"],
                )}
                onClick={handleCourseAssessmentRedirection}
              >
                <div className={styles.course}>
                  <div className={styles["course-id"]}>
                    <img src={CourseAssessmentIcon} alt="assessment" />
                  </div>

                  <div className={styles["course-detail"]}>
                    <p className={styles["course-description"]}>
                      {getTranslatedText(
                        translatedText,
                        "key_course_assessment",
                        "Course Assessment",
                      )}
                    </p>
                    {renderAssessmentText()}
                  </div>
                </div>

                {isAllModulesCompleted ? (
                  <img
                    src={ArrowIcon}
                    className={styles["assessment-chevron"]}
                    alt="Icon"
                  />
                ) : (
                  <img src={ModuleLock} alt="Icon" />
                )}
              </div>
            ) : null)}
        </div>
      </div>

      {showMessage && (
        <ToastContainer autoClose={2000} position="top-right" limit={1} />
      )}

      <EnrollmentSuccessfulComponent
        enrollmentSuccessfull={enrollmentSuccessfull}
        handleClick={handleClick}
        isPending={enrolling}
        preAssessment={preAssessment}
      />
    </>
  );
};

export default ModuleListUiComponent;
